import { computed, reactive } from '@nuxtjs/composition-api';
import useMyGarage from '@shared/composables/useMyGarageSparesbox';
import { IUserSelectedVehicle } from '@shared/types/IVehicleSelection';

const state = reactive({
  userSelectedVehicle: null as IUserSelectedVehicle | null,
  vehiclesInGarage: null as IUserSelectedVehicle[] | null,
});

const useVehicleSelectionSparesbox = () => {
  const userSelectedVehicle = computed(() => state.userSelectedVehicle);

  const setUserSelectedVehicle = (selectedVehicle: IUserSelectedVehicle | null) => {
    state.userSelectedVehicle = selectedVehicle;
  };

  const vehiclesInGarage = computed(() => state.vehiclesInGarage);
  const setVehiclesInGarage = (vehicles: IUserSelectedVehicle[] | null) => {
    state.vehiclesInGarage = vehicles;
  };

  const initInBrowserState = async () => {
    const myGarage = useMyGarage();

    // Ensure cookie and localStorage are in sync
    myGarage.syncSelectionCookieWithLocalstorage();

    // Load synced selections into app state
    const [userVehicleSelection, vehiclesInGarage] = await Promise.all([
      myGarage.getVehicleSelectionFromCookie(), // userVehicleSelection
      myGarage.getAllVehicleSelectionsFromLs(), // vehiclesInGarage
    ]);

    setVehiclesInGarage(vehiclesInGarage);
    if (userVehicleSelection) {
      setUserSelectedVehicle(userVehicleSelection);
    }
  };

  return {
    vehiclesInGarage,
    userSelectedVehicle,
    setVehiclesInGarage,
    setUserSelectedVehicle,
    initInBrowserState,
  };
};

export default useVehicleSelectionSparesbox;
